var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountUnderReview({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 464,
    height: 241,
    viewBox: "0 0 464 241",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2528_4662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.839 232.196C338.124 232.058 335.458 231.425 332.971 230.328C332.308 230.04 331.787 229.501 331.522 228.829C331.257 228.158 331.27 227.408 331.559 226.746C331.847 226.084 332.387 225.563 333.059 225.298C333.732 225.034 334.482 225.047 335.145 225.335C337.655 226.42 340.871 227.05 341.741 226.681C343.316 224.911 345.761 214.164 342.61 209.04C342.443 208.679 342.192 208.362 341.879 208.117C341.565 207.871 341.197 207.704 340.806 207.629C339.013 207.39 336.362 209.225 335.427 210.104C334.9 210.595 334.199 210.856 333.478 210.831C332.758 210.805 332.077 210.495 331.586 209.968C331.094 209.441 330.833 208.741 330.858 208.021C330.884 207.302 331.194 206.622 331.722 206.131C332.221 205.664 336.731 201.593 341.502 202.244C342.692 202.423 343.825 202.872 344.814 203.557C345.803 204.242 346.621 205.145 347.206 206.196C351.846 213.73 348.663 228.092 345.109 230.936C343.869 231.825 342.364 232.269 340.839 232.196Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.025 200.02H306.001V239.828H336.025V200.02Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.729 197.838C308.729 197.838 308.729 194.527 314.803 191.216C320.877 187.904 324.213 182.922 320.888 173.531C317.563 164.141 318.128 157.508 324.768 151.982",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.108 162.502C310.413 158.463 312.227 155.055 315.911 151.982",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.043 173.532C311.441 171.858 310.951 170.147 310.576 168.408",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.428 176.767C333.191 175.662 332.883 174.574 332.505 173.51C332.331 173 332.157 172.5 332.005 172.012",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.334 197.838C320.334 197.838 320.334 194.527 326.419 191.216C330.418 189.045 333.211 186.146 333.732 181.771",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.358 192.148C387.358 192.148 383.99 187.871 380.328 186.047C376.666 184.223 369.026 182.682 369.026 182.682C369.026 182.682 375.742 181.162 380.98 182.378C386.217 183.594 389.847 188.794 389.847 188.794C389.847 188.794 388.314 186.622 386.174 180.239C384.033 173.856 384 160.102 384 160.102C387.257 163.905 389.83 168.243 391.607 172.922C393.086 177.177 394.11 181.577 394.66 186.047C394.66 186.047 394.052 175.365 395.888 169.264C397.725 163.163 402.908 155.531 402.908 155.531C402.908 155.531 403.212 168.949 401.083 176.277C398.953 183.605 398.018 186.959 398.018 186.959C399.358 183.154 401.556 179.707 404.44 176.885C409.015 172.618 420.012 168.949 420.012 168.949C420.012 168.949 414.818 178.415 411.46 181.466C408.102 184.516 404.745 187.871 404.745 187.871C407.751 185.967 411.26 185.01 414.818 185.124C421.24 185.124 428.868 189.402 428.868 189.402C428.868 189.402 406.581 189.098 402.3 192.756L387.358 192.148Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.498 190.499L387.738 187.904",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.552 192.527L390.347 178.643",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.976 194.266L398.453 174.02",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.552 192.529L405.397 180.381",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.628 191.279L408.004 187.609",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.981 239.828H382.501L381.121 228.765C380.117 220.69 380.07 212.524 380.979 204.437L382.501 190.922H413.036L414.535 204.144C415.461 212.222 415.424 220.381 414.426 228.451L412.981 239.828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.002 219.049L410.428 191.28L404.31 239.187L393.628 191.28L387.206 239.806L382.446 190.922",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.002 219.049L410.428 191.28L404.31 239.187L393.628 191.28L387.206 239.806L382.446 190.922",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.981 239.828H382.501L381.121 228.765C380.117 220.69 380.07 212.524 380.979 204.437L382.501 190.922H413.036L414.535 204.144C415.461 212.222 415.424 220.381 414.426 228.451L412.981 239.828Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.913 239.828H1.11914",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.689 99.873C213.689 99.873 210.788 119.739 213.689 123.474C216.591 127.208 223.219 130.096 232.749 132.994C242.279 135.893 248.495 129.672 257.601 140.029C266.707 150.385 274.183 176.863 279.149 185.146C284.115 193.429 289.929 206.26 291.222 215.824C292.515 225.388 288.321 230.719 280.029 231.967C271.738 233.216 257.21 212.926 255.591 210.027C253.972 207.129 246.006 197.576 246.006 197.576C246.006 197.576 241.443 231.109 241.443 232.76C241.443 234.41 241.855 239.794 241.855 239.794H122.53C122.53 239.794 131.647 190.129 134.125 172.738C136.602 155.346 135.374 143.763 145.317 137.554C155.26 131.344 164.377 133.005 171.006 130.932C177.634 128.858 181.774 127.208 182.198 123.485C182.622 119.761 182.611 102.37 182.611 102.37L213.689 99.873Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.833 220.244L72.2617 234.596L76.5757 239.85H138.808",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.833 220.244L72.2617 234.596L76.5757 239.85H138.808",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3076 229.113C62.9155 227.629 60.2358 226.668 57.445 226.294C54.6542 225.92 51.8157 226.141 49.1165 226.942C40.282 229.515 35.8594 237.244 35.8594 239.817H73.0446C72.5849 237.588 71.6577 235.482 70.3241 233.637C68.9905 231.792 67.2808 230.25 65.3076 229.113Z",
    fill: "#181818",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4883 220.287C42.4883 220.287 37.6961 227.278 37.6961 229.851C37.6961 232.424 35.1208 234.997 38.7828 236.104C42.4448 237.211 44.6724 224.336 44.6724 222.871C44.6724 221.405 42.4883 220.287 42.4883 220.287Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1166 219.929C49.1166 219.929 43.955 218.843 42.488 220.287C41.021 221.731 38.4348 234.638 38.8043 236.104C39.1737 237.569 42.8575 237.939 43.955 236.473C45.0525 235.007 49.1166 219.929 49.1166 219.929Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6715 231.012L77.9783 230.024C77.4868 229.435 76.949 228.887 76.3701 228.385C74.7297 227.365 72.9981 226.5 71.1976 225.801C71.1976 225.801 55.7346 220.275 52.4203 218.072C49.106 215.868 47.2695 220.243 46.172 222.859C45.0745 225.475 42.4883 234.627 42.4883 237.2C42.4883 239.772 46.5306 240.869 47.2695 237.927C48.0085 234.985 53.8981 225.432 53.8981 225.432L61.6242 228.374C61.6242 228.374 62.3631 229.459 59.0488 231.685C55.7346 233.91 50.9533 238.665 52.4203 239.403C53.8873 240.142 58.3099 239.772 59.7878 238.318C61.2656 236.863 68.9917 235.061 68.9917 235.061C68.9917 235.061 75.9897 239.479 77.4567 239.848C78.4063 239.987 79.366 240.045 80.3255 240.022H89.3012C89.6859 238.421 89.6456 236.748 89.1844 235.168C88.7232 233.588 87.857 232.155 86.6715 231.012Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9941 231.011C59.9941 231.011 63.2541 227.299 65.8947 226.854",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.836 200.953C277.771 202.229 281.628 203.734 285.387 205.458C290.745 207.988 292.722 214.143 291.907 221.796C291.092 229.45 285.703 235.323 277.781 233.065C269.859 230.807 265.654 224.38 265.371 219.256C265.089 214.132 262.796 202.636 273.836 200.953Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.066 157.04C171.419 156.377 159.325 144.903 152.099 134.394C159.368 131.962 165.921 132.549 171.006 130.964C177.635 128.89 181.775 127.24 182.199 123.517C182.623 119.793 182.612 102.402 182.612 102.402L213.69 99.916C213.69 99.916 210.789 119.782 213.69 123.517C216.591 127.251 223.22 130.139 232.75 133.037C236.923 134.296 240.454 133.819 243.888 133.754C238.292 139.855 219.08 158.071 190.066 157.04Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.558 114.843C184.896 117.101 187.485 119.086 190.273 120.759C195.25 123.56 203.769 121.074 206.257 117.969C207.475 116.449 209.985 113.453 212.669 109.849C213.049 104.606 213.755 99.916 213.755 99.916L182.677 102.402C182.677 102.402 182.612 108.926 182.558 114.843Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.465 164.607C277.465 164.607 260.546 186.861 258.851 196.165C257.155 205.468 251.798 227.972 251.798 227.972C251.798 227.972 235.444 235.018 225.012 235.3C214.581 235.582 196.531 233.889 196.531 233.889C196.531 233.889 208.093 204.089 212.603 189.119C217.112 174.149 218.243 165.736 218.243 165.736C218.243 165.736 243.909 169.112 258.568 165.736L280.562 160.666L277.465 164.607Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.661 211.266C276.661 211.266 274.597 185.212 272.108 184.365C269.62 183.518 254.722 181.466 250.56 182.291C246.398 183.116 245.127 184.777 248.495 185.602C251.864 186.428 257.601 187.263 260.09 187.676C262.899 188.343 265.668 189.173 268.381 190.162C268.381 190.162 259.264 191.399 255.537 191.399C251.809 191.399 243.105 195.123 242.692 196.827C242.448 197.81 242.596 198.85 243.105 199.726C242.886 200.58 242.909 201.478 243.171 202.32C243.583 203.981 253.461 203.156 255.95 203.569C258.438 203.981 263.404 205.176 263.404 205.176C263.404 205.176 248.908 204.351 248.908 207.249C248.908 210.148 255.113 209.724 257.601 209.724C260.614 210.056 263.48 211.201 265.892 213.035C267.131 214.284 266.718 220.775 270.446 222.024C272.044 222.651 273.717 223.067 275.422 223.261",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.661 211.266C276.661 211.266 274.597 185.212 272.108 184.365C269.62 183.518 254.722 181.466 250.56 182.291C246.398 183.116 245.127 184.777 248.495 185.602C251.864 186.428 257.601 187.263 260.09 187.676C262.899 188.343 265.668 189.173 268.381 190.162C268.381 190.162 259.264 191.399 255.537 191.399C251.809 191.399 243.105 195.123 242.692 196.827C242.448 197.81 242.596 198.85 243.105 199.726C242.886 200.58 242.909 201.478 243.171 202.32C243.583 203.981 253.461 203.156 255.95 203.569C258.438 203.981 263.404 205.176 263.404 205.176C263.404 205.176 248.908 204.351 248.908 207.249C248.908 210.148 255.113 209.724 257.601 209.724C260.614 210.056 263.48 211.201 265.892 213.035C267.131 214.284 266.718 220.775 270.446 222.024C272.044 222.651 273.717 223.067 275.422 223.261",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.105 199.683C243.105 199.683 259.677 195.948 267.968 200.095",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.217 177.33C153.217 177.33 146.589 200.507 147.838 208.812C149.088 217.117 152.804 226.605 153.217 227.853C153.63 229.102 151.761 238.915 151.761 238.915",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.558 49.003C143.286 45.2794 139.558 43.206 139.971 39.0699C140.384 34.9338 144.524 32.8603 146.6 32.0353C148.675 31.2103 147.839 29.1368 148.262 24.5773C148.686 20.0179 153.641 18.3678 156.956 17.1302C160.27 15.8926 158.205 13.8734 159.857 10.5081C161.509 7.1428 170.637 8.02215 170.637 8.02215C170.637 8.02215 172.701 4.29857 175.19 4.29857C177.678 4.29857 179.33 7.60961 182.644 4.71109C185.958 1.81258 188.86 0.575003 193.424 2.22509C194.898 2.81111 196.412 3.29002 197.955 3.65807C199.502 3.29171 201.02 2.81277 202.497 2.22509C207.05 0.575003 209.952 1.81258 213.266 4.71109C216.58 7.60961 218.243 4.29857 220.731 4.29857C223.22 4.29857 225.284 8.02215 225.284 8.02215C225.284 8.02215 234.401 7.19708 236.064 10.5081C237.726 13.8192 235.64 15.8818 238.954 17.1302C242.269 18.3786 247.246 20.0287 247.648 24.5773C248.05 29.1259 247.235 31.1994 249.31 32.0353C251.386 32.8712 255.526 34.9229 255.939 39.0699C256.352 43.2168 252.679 45.2794 256.352 49.003C260.025 52.7266 263.806 55.6251 260.492 58.1111C257.178 60.597 253.863 61.4221 254.276 65.1457C254.689 68.8692 258.84 73.4287 255.526 75.4913C252.212 77.5539 248.897 77.5648 248.897 81.2883C248.897 85.0119 250.136 90.3964 246.409 91.2214C242.682 92.0464 237.292 91.2214 237.292 93.7074C237.292 96.1934 236.879 100.742 231.076 99.917C225.273 99.0919 223.209 97.4309 221.959 100.742C220.71 104.053 217.819 106.17 214.505 105.714C211.19 105.258 206.627 104.889 203.725 107.364C202.295 108.476 200.59 109.181 198.792 109.405V109.546C198.509 109.546 198.227 109.546 197.944 109.546C197.662 109.546 197.379 109.546 197.097 109.546V109.405C195.299 109.177 193.596 108.473 192.163 107.364C189.262 104.889 184.709 105.301 181.394 105.714C178.08 106.127 175.179 104.053 173.94 100.742C172.701 97.4309 170.626 99.0919 164.823 99.917C159.02 100.742 158.607 96.1934 158.607 93.7074C158.607 91.2214 153.174 92.0573 149.49 91.2214C145.807 90.3855 147.002 85.0119 147.002 81.2883C147.002 77.5648 143.742 77.5648 140.373 75.4913C137.005 73.4178 141.199 68.8692 141.612 65.1457C142.025 61.4221 138.711 60.597 135.397 58.1111C132.082 55.6251 135.831 52.7266 139.558 49.003Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.777 71.8754C172.777 71.8754 168.061 64.8082 165.225 68.1084C162.389 71.4086 163.345 79.887 167.116 84.1316C170.887 88.3763 175.124 86.9542 175.124 86.9542",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.777 71.8754C172.777 71.8754 168.061 64.8082 165.225 68.1084C162.389 71.4086 163.345 79.887 167.116 84.1316C170.887 88.3763 175.124 86.9542 175.124 86.9542",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.209 71.5185C223.209 71.5185 228.718 65.005 231.142 68.6526C233.565 72.3001 231.631 80.594 227.393 84.3393C223.155 88.0845 219.102 86.2173 219.102 86.2173",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.209 71.5185C223.209 71.5185 228.718 65.005 231.142 68.6526C233.565 72.3001 231.631 80.594 227.393 84.3393C223.155 88.0845 219.102 86.2173 219.102 86.2173",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.242 54.8004C220.411 55.5544 219.421 56.1126 218.345 56.4338C217.27 56.7551 216.136 56.8313 215.027 56.6568C212.973 56.3588 210.98 55.732 209.126 54.8004C209.126 54.8004 205.399 57.2864 202.606 56.3528C199.813 55.4192 196.695 54.4856 196.695 54.4856C194.652 55.7382 192.214 56.1834 189.86 55.734C185.513 55.1044 184.263 54.1816 184.263 54.1816C184.263 54.1816 181.775 56.3528 179.297 56.3528C177.738 56.3474 176.181 56.2422 174.636 56.038C173.955 56.3754 173.219 56.5852 172.462 56.6568H170.289C170.289 56.6568 169.365 75.2854 172.462 88.6381C175.559 101.991 187.676 111.924 192.663 114.692C197.651 117.46 206.17 115.007 208.659 111.902C211.147 108.797 219.08 99.4831 222.785 91.4064C226.491 83.3296 227.762 59.7398 227.762 58.1875C227.762 56.6351 222.763 58.524 221.242 54.8004Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.704 65.6666C203.281 65.8465 202.923 66.1503 202.676 66.538C202.43 66.9256 202.307 67.3789 202.324 67.8378C202.432 71.3551 202.954 79.7141 205.399 81.1796C208.507 83.036 223.014 84.4364 226.534 82.1024C228.393 80.8648 232.435 69.9981 230.881 66.9042C229.327 63.8103 216.135 60.5643 203.704 65.6666Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.108 65.6666C194.531 65.8465 194.89 66.1503 195.136 66.538C195.382 66.9256 195.505 67.3789 195.488 67.8378C195.38 71.3551 194.858 79.7141 192.413 81.1796C189.305 83.036 174.799 84.4364 171.278 82.1024C169.42 80.8648 165.377 69.9981 166.931 66.9042C168.485 63.8103 181.677 60.5643 194.108 65.6666Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.703 65.6665C203.703 65.6665 197.944 64.4181 194.206 66.2853",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.671 69.3906H195.76",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.995 77.4661C212.027 77.4661 212.864 75.9351 212.864 74.0465C212.864 72.158 212.027 70.627 210.995 70.627C209.963 70.627 209.126 72.158 209.126 74.0465C209.126 75.9351 209.963 77.4661 210.995 77.4661Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.859 77.4661C190.892 77.4661 191.728 75.9351 191.728 74.0465C191.728 72.158 190.892 70.627 189.859 70.627C188.827 70.627 187.99 72.158 187.99 74.0465C187.99 75.9351 188.827 77.4661 189.859 77.4661Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.03 76.2188C201.03 76.2188 200.715 80.5611 202.269 82.1135C203.823 83.6659 205.681 84.9143 203.507 86.4558C201.334 87.9974 199.476 89.2458 196.368 86.4558",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.638 92.9797C206.638 92.9797 198.868 96.7142 192.033 91.7422",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.895 67.2191C215.667 66.3012 214.227 65.7059 212.708 65.4878C211.189 65.2697 209.64 65.4357 208.202 65.9707",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.413 66.9043C191.413 66.9043 184.263 63.1807 180.221 69.0754",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.21 126.199L192.967 185.809L178.667 128.685",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.859 188.609C189.859 189.285 190.06 189.947 190.436 190.509C190.812 191.071 191.347 191.51 191.972 191.768C192.598 192.027 193.286 192.095 193.95 191.963C194.614 191.831 195.224 191.505 195.703 191.027C196.181 190.549 196.507 189.939 196.639 189.276C196.772 188.613 196.704 187.925 196.445 187.3C196.186 186.676 195.747 186.142 195.184 185.766C194.621 185.39 193.959 185.189 193.282 185.189C192.374 185.189 191.504 185.55 190.862 186.191C190.22 186.832 189.859 187.702 189.859 188.609Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.044 239.838H209.691V236.939H116.044V239.838Z",
    fill: "#181818",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6826 176.082H141.732L160.792 239.828H66.7425L47.6826 176.082Z",
    fill: "#181818",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2528_4662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 464,
    height: 241,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountUnderReview);
export default __webpack_public_path__ + "static/media/AccountUnderReview.3cde326530a229dbb1e6e5acc63b1409.svg";
export { ForwardRef as ReactComponent };